import { useContext } from 'react';
import Text from '@ingka/text';
import PageTitle from '../components/PageTitle';
import PageContent from '../components/PageContent';
import StickyHeader from '../components/StickyHeader';
import { styled } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ViewContext } from '../context';

const StyledHeader = styled(Text)`
  &&& {
    text-align: center;
    margin: 0.67em 0;
  }
`;

const StyledText = styled(Text)`
  &&& {
    text-align: center;
  }
`;

const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const view = useContext(ViewContext);
  const isViewAlt = view === 'alt';

  return (
    <>
      <PageTitle title="404" />
      {isViewAlt && <StickyHeader />}
      <PageContent>
        <StyledHeader tagName={isViewAlt ? 'h2' : 'h1'} textStyle="Heading.M">
          {t('pages.404.title')}
        </StyledHeader>
        <StyledText tagName="p" textStyle="Body.S">
          {t('pages.404.description')}
        </StyledText>
      </PageContent>
    </>
  );
};

export default NotFoundPage;
